import { clearCsrfToken, CSRF_HEADER, getCsrfToken } from './csrf';
import { apiUrl } from './url';

/**
 * POST /api/v1/auth/logout. Served by Spring Security's logout filter rather than a documented
 * controller, so it has no OpenAPI schema entry and can't ride the typed {@link apiClient}.
 * It lives in the seam alongside the other untyped HTTP plumbing (csrf, the unauthorized
 * signal) so no module needs a raw `fetch` — the apiRequest seam guard stays exception-free.
 *
 * Consumers navigate to /login once the mutation settles, so a 401 here needs no global
 * unauthorized signal.
 */
export async function logout(): Promise<void> {
  const headers = new Headers();
  const token = getCsrfToken();
  if (token) headers.set(CSRF_HEADER, token);
  await fetch(apiUrl('api/v1/auth/logout'), {
    method: 'POST',
    headers,
    credentials: 'include',
  });
  clearCsrfToken();
}
